@if(initialized && objectLoaded && dto){


<!--  <p-tabView [(activeIndex)]="activeTabIndex">-->
<!--    <p-tabPanel header="Übersicht">-->

<!--      @if (activeTabIndex == 0) {-->
<!--      <cm-contract-standard-navigation-consultant-->
<!--        [objectIdentifier]="objectIdentifier">-->
<!--      </cm-contract-standard-navigation-consultant>-->
<!--      }-->
<!--    </p-tabPanel>-->

<!--    <p-tabPanel header="Dokumente">-->

<!--      @if (activeTabIndex == 1) {-->
<!--      <cm-contract-document-upload-consultant-->
<!--        [objectIdentifier]="objectIdentifier">-->
<!--      </cm-contract-document-upload-consultant>-->
<!--      }-->
<!--    </p-tabPanel>-->

<!--    <p-tabPanel header="Tickets">-->

<!--      @if (activeTabIndex == 2) {-->
<!--        <cm-contract-tickets-->
<!--        [contractId]="objectIdentifier.objectId"></cm-contract-tickets>-->
<!--      }-->
<!--    </p-tabPanel>-->

<!--    <p-tabPanel header="Objekte/ Personen">-->

<!--      @if (activeTabIndex == 3) {-->
<!--        <cm-contract-objects-navigation-consultant-->
<!--          [contractDto]="dto"-->
<!--          [customerDto]="dto.joinCurrentMainCustomer">-->
<!--        </cm-contract-objects-navigation-consultant>-->
<!--      }-->
<!--    </p-tabPanel>-->


<!--  </p-tabView>-->
    <p-tabs class="bg-transparent-tabview" [(value)]="activeTabIndex">
        <p-tablist>
            <p-tab [value]="0">Übersicht</p-tab>
            <p-tab [value]="1">Dokumente</p-tab>
            <p-tab [value]="2">Tickets</p-tab>
            <p-tab [value]="3">Objekte / Personen</p-tab>
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel [value]="0">
                @if (activeTabIndex === 0) {
                    <cm-contract-standard-navigation-consultant
                            [objectIdentifier]="objectIdentifier">
                    </cm-contract-standard-navigation-consultant>
                }
            </p-tabpanel>

            <p-tabpanel [value]="1">
                @if (activeTabIndex === 1) {
<!--                    <cm-contract-document-upload-consultant-->
<!--                            [objectIdentifier]="objectIdentifier">-->
<!--                    </cm-contract-document-upload-consultant>-->
                    <div class="grid">
                        <div class="col-12">
                            <mvs-dm-object-documents-consultant
                                    [objectIdentifier]="objectIdentifier"
                                    layoutVariation="contract"
                            ></mvs-dm-object-documents-consultant>
                        </div>
                    </div>
                }
            </p-tabpanel>

            <p-tabpanel [value]="2">
                @if (activeTabIndex === 2) {
<!--                    <cm-contract-tickets-->
<!--                            [contractId]="objectIdentifier.objectId">-->
<!--                    </cm-contract-tickets>-->
                    <mvs-ticket
                        [readonly]="true"
                        aliasSuffix=":co"
                        [objectIdentifier]="objectIdentifier">

                    </mvs-ticket>
                }
            </p-tabpanel>

            <p-tabpanel [value]="3">
                @if (activeTabIndex === 3) {
                    <cm-contract-objects-navigation
                            aliasSuffix=":co"
                            [contractDto]="dto"
                            [customerDto]="dto.joinCurrentMainCustomer"
                            [readOnly]="true"
                    >
                    </cm-contract-objects-navigation>
                }
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>

}
